<section class="container-fluid px-0"
         style="background: url(assets/img/landing-new/db-devops-serverless/57838.jpg); background-position: right; background-size: cover">
    <div class=" mt-0 hero w-100 d-flex align-items-center">
        <div class="container">
            <div class="row ">
                <div class="align-items-center col-md-8  hero-text">
                    <h1 class="text-white w-100 fw-bold">Scalable, Efficient and Future-Ready: Serverless Computing and Cloud Migration Services</h1>
                    <p class="text-white">
                        Empower your business via enhancing scalability, reducing cost, and optimizing efficiency with Volmint’s Serverless & Integration Solutions. Experience the power of digital infrastructure with quality cloud migration services and serverless monitoring that drive business success with ease.
                    </p>
                    <div class="hero-buttons">
                        <button class="btn-primary" (click)="openModal()">Get Started </button>
                    </div>
                    <ng-template #contactFormModal>
                        <app-contact-form [isModalOpen]="isModalOpen"
                                          (closeModal)="closeModal()"></app-contact-form>
                    </ng-template>
                    <div *ngIf="isModalOpen" class="modal-overlay" (click)="handleOverlayClick($event)">
                        <ng-container *ngTemplateOutlet="contactFormModal"></ng-container>
                    </div>
                </div>
                <div class="col-md-6"></div>
            </div>
        </div>


    </div>

</section>
<div class="container-fluid bg-light py-5">

</div>
<div class="container-fluid position-relative">
    <div class="container  shadow-sm ">
        <div class="row bg-white py-0 shadow position-absolute w-75" style="top :-50px" >
            <div class="col-md-6 ps-md-5 py-md-5 py-4">
                <h2 class=" fs-1 fw-bolder ">About Volmint’s Serverless & Integration Solutions
                </h2>
                <p>At Volmint Technologies, we redefine IT operations with serverless computing services that cater to unique business needs while reducing migration costs and efforts. We are a leading vendor of internal developer platform technologies, identity and access management, API management, and integration.

                </p>
                <p>
                    By going serverless, businesses can increase performance, reduce operating costs, and automatically scale up workload without user intervention. Serverless architecture on AWS widespread acceptance and dependability. Whether you're moving to the cloud, automating workflows, or integrating new IT systems, Volmint ensures that every step is seamless, secure, and efficient.

                </p>
                <p>We strengthen business IT infrastructure with a proactive approach, identify vulnerabilities, mitigate risks, and implement solutions that increase overall operational efficiency. Let our experts design, implement, and manage solutions that reduce risks, improve operational efficiency, and maintain trust across stakeholders.
                </p>
            </div>
            <div class="col-md-6 m-0 p-0 text-right ">
                <img src="https://img.freepik.com/premium-photo/waist-up-portrait-smiling-african-american-man-standing-by-server-cabinet-while-working-with-supercomputer-data-center-holding-tablet-copy-space_236854-29016.jpg"
                     class="w-100 h-100"
                     alt="Image">
            </div>
        </div>
    </div>
</div>
<div class="container-fluid mt-50px" style="margin-top: 500px">
    <div class=" container py-5">

        <div class="row gy-3 pb-5 ">
            <div class="col-md-6 px-md-5">
                <h2 class=" fs-1  fw-bold justify-text"> Why Choose Volmint’s Serverless & Integration Services?</h2>
                <p class=" ">At Volmint Technologies, our DevSecOps services are designed to integrate
                    security throughout the development process. We focus on three key areas: SAST integration, DAST
                    integration, and Web security, ensuring your applications are secure from code to deployment.
                </p>
                <img src="https://img.freepik.com/premium-photo/person-standing-server-room-looking-rows-servers-with-digital-network-overlay_36682-215438.jpg?w=360" alt="" class="w-100"/>
            </div>

                <div class="col-md-6  px-md-5">
                    <ng-container  *ngFor="let item of whyChoose1; let i = index">

                    <div class="dashed-border  mt-3 d-flex">
                        <div>
                            <div class=" align-items-center p-2  border-left    fw-bold ">
                                <i [ngClass]="item.icon" class="fs-4 blue-color"></i></div>
                        </div>

                        <div class="px-3 pb-3">
                            <h3 class="fs-6 fw-bold">{{ item.header }}</h3>
                            <p class=" justify-text">{{
                                    item.text
                                }}</p>
                        </div>

                    </div>
                    </ng-container>

                </div>
        </div>
    </div>
</div>

<div class="container-fluid ">
    <div class="container py-5">
        <h2 class="   fw-bold justify-text"><span class="blue-color"> Our Services  -</span>  CComprehensive Solutions for Modern IT Challenges</h2>
        <p>To help businesses stay agile and efficient, Volmint Technologies offers numerous serverless & Integration solutions. From serverless computing to seamless migration and advanced monitoring, we ensure reliable, secure, and scalable IT operations.</p>
        <div class=" row my-5 mx-auto my col-12 row">
            <div class="tab-titles col-md-4  px-0" *ngFor="let tab of tabs; let i = index">
                <button class="w-100 py-3 btn text-nowrap rounded-0"
                        [class.active]="i === selectedIndex"
                        (click)="selectTab(i)">
                    {{ tab.title }}
                </button>
            </div>
            <div class="tab-content row border mx-auto">
                <div class="col-md-5 p-6">
                    <img [src]="tabs[selectedIndex].content.img" alt="">
                </div>
                <div class="col-md-7 border-start p-4">
                    <h3 class="blue fw-semibold">
                        {{tabs[selectedIndex].title}}
                    </h3>
                    <p>{{tabs[selectedIndex].content.detail}}</p>
                    <ul>
                        <li *ngFor="let item of tabs[selectedIndex].content.list">
                            <p>
                                {{item}}
                            </p>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</div>
<div class="container-fluid bg-light">
    <div class="container  py-5">
        <div class="row align-items-center">
            <div class="col-md-5  p-5">
                <h2>
                    Our Process: A Step-by-Step Approach to IT Transformation
                </h2>
                <img src="assets/img/landing-new/db-devops-serverless/business.png"
                     class="img-fluid border-radius-10"
                     alt="Image">
            </div>
            <div class="col-md-7 px-5">
                <div class="row  bg-white mb-3">
                    <div class="col-2 p-0">
                        <img class="img-fluid w-100 h-100" src="https://img.freepik.com/free-photo/cloud-storage-banner-background-remixed-from-public-domain-by-nasa_53876-124623.jpg?uid=R138008852&ga=GA1.1.1980573325.1732262409&semt=ais_hybrid" alt="">
                    </div>
                    <div class="col-10 py-3">
                        <h3 class="fs-4">Comprehensive Needs Assessment:</h3>
                        <p>Our journey starts by consulting and evaluating your current infrastructure and addresses the area that needs improvement. We will then provide solutions that align with your business-specific needs.</p>
                    </div>
                </div>
                <div class="row bg-white mb-3">
                    <div class="col-2 p-0">
                        <img  class="img-fluid w-100 h-100"  src="https://img.freepik.com/free-photo/cloud-storage-banner-background-remixed-from-public-domain-by-nasa_53876-124623.jpg?uid=R138008852&ga=GA1.1.1980573325.1732262409&semt=ais_hybrid" alt="">

                    </div>
                    <div class="col-10 py-3">
                        <h3 class="fs-4">Strategic Planning and Design</h3>
                        <p> With the right approach and collaboration, we follow a unique strategy to design tailored solutions to optimize your IT operations, implementing best practices and platforms for your business.
                        </p>
                    </div>
                </div>
                <div class="row bg-white mb-3">
                    <div class="col-2 p-0">
                        <img  class="img-fluid w-100 h-100"  src="https://img.freepik.com/free-photo/cloud-storage-banner-background-remixed-from-public-domain-by-nasa_53876-124623.jpg?uid=R138008852&ga=GA1.1.1980573325.1732262409&semt=ais_hybrid" alt="">

                    </div>
                    <div class="col-10 py-3">
                        <h3 class="fs-4">Seamless Implementation</h3>
                        <p>The next step is to execute and implement using proven methodologies. We design and deploy solutions with minimal disruption, and ensure a smooth transaction to modernize IT systems.</p>
                    </div>
                </div>
                <div class="row bg-white mb-3">
                    <div class="col-2 p-0">
                        <img  class="img-fluid w-100 h-100"  src="https://img.freepik.com/free-photo/cloud-storage-banner-background-remixed-from-public-domain-by-nasa_53876-124623.jpg?uid=R138008852&ga=GA1.1.1980573325.1732262409&semt=ais_hybrid" alt="">

                    </div>
                    <div class="col-10 py-3">
                        <h3 class="fs-4">Continuous Monitoring and Support</h3>
                        <p>Our work does not just end with post-deployment, we offer continuous monitoring and support to keep your system performing and addressing any issues proactively.</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<div class="container-fluid parallax3">
    <div class=" container py-5">
        <h2 class=" text-white  fw-bold justify-text"> Why Volmint’s Serverless Computing Services Stands Out in IT Solutions</h2>
        <div class="row gy-3 pb-5 ">
            <ng-container  *ngFor="let item of benifits; let i = index">
                <div class="col-md-4  px-2"      [ngClass]="{
    'col-md-8': i === 0 || i === 3,
    'col-md-4': i === 1 || i === 2
  }">
                    <div class="bg-white border-brown-left h-100 pt-3 blue-shadow">
<!--                        <div class="d-flex align-items-center p-3  border-brown-left    fw-bold "><i [ngClass]="item.icon" class="fs-1 blue-color"></i></div>-->
                        <div class="px-3 pb-3   ">
                            <h3 class="fs-5 my-2 fw-bold blue-color">{{ item.header }}</h3>
                            <p class=" justify-text">{{
                                    item.text
                                }}</p>
                        </div>

                    </div>
                </div>
            </ng-container>
        </div>
    </div>

</div>

<div class="container-fluid">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="col-12">
                    <img src="assets/img/landing-new/mobile-development/faq.png" alt="Image" class="img-fluid w-50"/>
                    <p class="fs-1 fw-bold">Frequently Asked Questions</p>
                    <p class="text-muted">Have a question that is not answered? You can contact us at</p>
                    <p class="blue-color fw-bold">Email: <a href="mailto:support@volmint.com"
                                                             class="text-decoration-underline blue-color">support@volmint.com</a>
                    </p>
                    <button type="submit"
                            class="brand-primary-bg border-0 color-white px-5 py-2 fs-6 mt-4 fw-bold hover-effect"
                            (click)="goTo('/faq')">
                        View All Faqs
                    </button>
                </div>
            </div>
            <div class="col-12 col-md-6 mt-4">
                <div class="accordion" id="faqAccordion">
                    <div class="accordion-item shadow-lg border-0">
                        <h2 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                <span class="fs-6 fw-bold" style="color: #4f689a;">
                                    <div class="row w-100 align-items-center">
                                        <div class="col-1">
                                          <div class="encircled-icon float-start">
                                                <i class="fas fa-question fw-bold"></i>
                                          </div>
                                        </div>
                                        <div class="col-10 ps-3">
                                        Why are serverless computing services beneficial for my business?
                                        </div>
                                    </div>
                                </span>
                            </button>
                        </h2>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Serverless and Integration services eliminate the need for complex server management, allowing your developers to work on a fully managed IT platform that increases productivity and reduces the cost of infrastructure management.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h2 class="accordion-header" id="headingTwo">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <span
                            class="fs-6 fw-bold" style="color: #4f689a;">
                             <div class="row w-100 align-items-center">
                                        <div class="col-1">
                                            <div class="encircled-icon float-start">
                                                <i class="fas fa-question fw-bold"></i>
                                            </div>
                                        </div>
                                 <div class="col-10 ps-3">
                                     How do you ensure a smooth cloud migration services process?
                                 </div>
                             </div>
                            </span>
                            </button>
                        </h2>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                We have a team of dedicated experts who planned a detailed strategy including risk management, minimal downtime, and a structured approach to migration, ensuring seamless transactions.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h2 class="accordion-header" id="headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                <span class="fs-6 fw-bold" style="color: #4f689a;">
                                    <div class="row w-100 align-items-center">
                                        <div class="col-1">
                                            <div class="encircled-icon float-start">
                                                <i class="fas fa-question fw-bold"></i>
                                            </div>
                                        </div>
                                        <div class="col-10 ps-3">
                                            Which platforms does Volmint support for serverless solutions?
                                        </div>
                                    </div>
                                </span>
                            </button>
                        </h2>
                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                We are offering personalized solutions on leading platforms such as AWS, Google Cloud Platform, and Microsoft Azure.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h2 class="accordion-header" id="headingFour">
                            <button class="accordion-button collapsed w-100" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                <span class="fs-6 fw-bold w-100" style="color: #4f689a;">
                                    <div class="row w-100  align-items-center">
                                        <div class="col-1 ">
                                            <div class="encircled-icon ">
                                                <i class="fas fa-question fw-bold"></i>
                                            </div>
                                        </div>
                                        <div class="col-10 ps-3">
                                            Do you offer end-to-end support?
                                        </div>
                                    </div>
                                </span>
                            </button>
                        </h2>
                        <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Our goal is to enhance business excellence by implementing the latest techniques and tools, providing comprehensive support from consulting to ongoing monitoring.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h2 class="accordion-header" id="headingFive">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                <span class="fs-6 fw-bold w-100" style="color: #4f689a;">
                                    <div class="row w-100 align-items-center">
                                        <div class="col-1">
                                            <div class="encircled-icon">
                                        <i class="fas fa-question fw-bold"></i>
                                            </div>
                                        </div>
                                        <div class="col-10 ps-3">
                                              How secure are your integration services?
                                        </div>
                                    </div>
                                </span>
                            </button>
                        </h2>
                        <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                    Our solutions prioritize compliance with regulatory standards and incorporate advanced security protocols to protect your data and systems.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid ums-bottom-bg ps-5 mt-5">
    <div class="container">
        <div class="row align-items-center py-5">
            <div class="col-md-10 col-12">
                <h1 class="text-white">Ready to Take Your Business Growth to the Next Level?</h1>
            </div>
            <div class="col-md-2 col-12">
                <button class="btn bg-white rounded-0 px-5 py-3 text-black fw-bold hover-effect"
                        (click)="goTo('/contact')">Contact Us
                </button>
            </div>
        </div>
    </div>
</div>








